import { TFunction } from 'i18next';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { updateWorkOrder, deleteWorkOrder } from '../../actions/workOrderActions';
import { IWorkOrder } from '../../models';
import { workOrderStatusEnum } from '../../models-enums';

interface Iprops {
    updateWorkOrder: typeof updateWorkOrder;
    deleteWorkOrder: typeof deleteWorkOrder;
    loading: boolean;
    colorButton?: string;
    t: TFunction;
    selectedWorkOrder: IWorkOrder;
    /*
     * Every button here changes or deletes the work order, so none of them belong on a visit being
     * viewed from History - that work order was closed on another job (MMG-4345).
     */
    isHistoricalMode: boolean;
}
export default class NotApplicableButtonRow extends Component<Iprops> {
    render() {
        if (this.props.isHistoricalMode) {
            return null;
        }

        return (
            <>
                {this.props.selectedWorkOrder.status !== workOrderStatusEnum.notApplicable && (
                    <Button
                        variant="default"
                        className="pull-right"
                        onClick={e =>
                            this.props.updateWorkOrder({
                                ...this.props.selectedWorkOrder,
                                status: workOrderStatusEnum.notApplicable
                            })
                        }
                    >
                        {String(this.props.t('notApplicable'))}
                    </Button>
                )}
                {this.props.selectedWorkOrder.status === workOrderStatusEnum.notApplicable && (
                    <Button
                        variant="default"
                        className="pull-right"
                        onClick={e =>
                            this.props.updateWorkOrder({
                                ...this.props.selectedWorkOrder,
                                status: workOrderStatusEnum.reopened
                            })
                        }
                    >
                        {String(this.props.t('reopen'))}
                    </Button>
                )}
                <Button
                    variant="danger delete-button"
                    className="pull-right"
                    onClick={() => {
                        this.props.deleteWorkOrder(this.props.t);
                    }}
                >
                    {String(this.props.t('common:delete'))}
                </Button>
            </>
        );
    }
}
